<template>
  <mdb-container fluid id="details" class="overflow-hidden">
    <mdb-row class="pt-3 pb-3 mb-3 d-flex blue-header">
      <mdb-col class="col-12 text-left pl-4 pr-4">
        <img
          class="logo"
          src="../assets/img/csc-white.svg"
          width="140"
          height="49"
        />
        <a
          class="link light consult-position"
          target="_blank"
          href="https://www.csc.gov.au/Employers/Contact-us"
        >
          <img
            class="icon-arrow-help"
            src="../assets/icons/big-arrow-white-outline.svg"
          />
          <span>Need help? Contact us</span>
        </a>
      </mdb-col>
    </mdb-row>

    <mdb-row class="pt-4 pb-4">
      <mdb-col class="flex-grow-7 flex-snap text-left"></mdb-col>

      <mdb-col
        class="flex-grow-3 flex-snap align-self-center text-right text-lg-left"
      >
        <WizardStep :step="2" />
      </mdb-col>
    </mdb-row>

    <mdb-row class="flex-row" responsive>
      <mdb-col
        class="flex-grow-7 flex-snap align-self-stretch p-0 pl-sm-2 pl-md-4"
      >
        <div class="details-inset">
          <mdb-container fluid>
            <mdb-row class="text-left dots-left">
              <mdb-col
                :class="lowerCase(reviewType)"
                class="col-12 p-0 pt-2 pl-5 small-circle small-dot-fix"
              >
                <h3>
                  {{ properCase(reviewType) }}
                  review on
                  {{ reviewDate }}
                </h3>
              </mdb-col>
            </mdb-row>

            <mdb-row class="text-left dots-left">
              <mdb-col
                class="col-12 p-0 pt-3 pb-3 pl-5 mt-2 mb-4 review-gradient"
              >
                <mdb-container fluid class="review-details">
                  <mdb-row>
                    <mdb-col class="col-6 col-lg-3 p-0 pt-2 pb-2">
                      <label class="review-name">
                        {{ employeeName }}
                      </label>
                      <div class="review-data review-number">
                        {{ memberNumber }}
                      </div>
                    </mdb-col>

                    <mdb-col class="col-6 col-lg-3 p-0 pt-2 pb-2">
                      <label>
                        Date of birth
                      </label>
                      <div class="review-data">
                        {{ birthDate }}
                      </div>
                    </mdb-col>

                    <mdb-col class="col-6 col-lg-3 p-0 pt-2 pb-2">
                      <label>
                        Super Scheme
                      </label>
                      <div class="review-data">
                        {{ formatSuperScheme(superScheme) }}
                      </div>
                    </mdb-col>

                    <mdb-col class="col-6 col-lg-3 p-0 pt-2 pb-2">
                      <label>
                        {{ getFirstName(employeeName) }}'s salary as at
                        {{ reviewDate }}
                      </label>
                      <div class="review-data">
                        ${{ formatCurrency(reviewSalary) }}
                      </div>
                    </mdb-col>
                  </mdb-row>
                  <mdb-row>
                    <mdb-col class="col-12 p-0 pt-2 pb-4">
                      <router-link
                        to="/about"
                        class="rounded btn btn-primary ripple-parent"
                      >
                        Edit employee
                      </router-link>
                    </mdb-col>
                  </mdb-row>
                </mdb-container>
              </mdb-col>
            </mdb-row>

            <mdb-row class="text-left dots-left">
              <mdb-col class="col-12 p-0 pt-5 big-circle">
                <h2>
                  Reduction Details
                </h2>
              </mdb-col>
            </mdb-row>

            <mdb-row class="text-left dots-left" id="formFields">
              <mdb-col class="pl-5 pt-4 pb-0"></mdb-col>
            </mdb-row>
            <ValidationObserver ref="observer" class="w-100">
              <ValidationProvider name="reductionReviewDate">
                <input
                  type="hidden"
                  name="reduction-review-date"
                  id="reduction-review-date"
                  :value="reviewDate"
                />
              </ValidationProvider>
              <!-- REDUCTION LOOP -->
              <mdb-row
                class="text-left dots-left"
                :key="index"
                v-for="(reduction, index) in reductionData"
              >
                <mdb-col class="col-12 p-0 pb-4">
                  <!-- Spacing above gradient -->
                </mdb-col>

                <mdb-col class="pl-5 pt-4 pb-md-4 dots-margin-adjust gradient">
                  <mdb-container fluid>
                    <mdb-row>
                      <mdb-col class="col-11 p-0 pt-2 pb-3">
                        <h4>
                          Reduction
                          {{ reductionNumber(index) }}
                        </h4>
                      </mdb-col>
                      <mdb-col class="col-1 p-0 pt-2 pb-3 pr-3 text-right">
                        <a
                          v-if="reductionCount > 1"
                          title="Delete Reduction"
                          class="trash"
                          @click="deleteReduction(index)"
                        >
                          <img src="../assets/icons/bin.svg" />
                        </a>
                      </mdb-col>
                    </mdb-row>

                    <mdb-row>
                      <mdb-col class="col-12 col-lg-12 p-0 pr-5 pt-3 pb-3">
                        <div class="form-group">
                          <mdb-tooltip
                            trigger="hover"
                            boundrySelector="#about-inset"
                            :options="{ placement: 'left' }"
                          >
                            <span slot="tip">
                              Enter the date of the salary reduction. The
                              effective date will be the first day that your
                              employee's pay was lowered. For example if the
                              salary reduction was caused by the loss of an
                              allowance, and the last day that the allowance was
                              paid was 1 January, the effective date would be 2
                              January. The calculator might instruct you to
                              enter a different effective date depending on your
                              answers to the questions above.
                            </span>
                            <span class="icon-info" slot="reference"></span>
                          </mdb-tooltip>

                          <label for="date-of-reduction"
                            >What was the date of this salary reduction?</label
                          >
                          <ValidationProvider
                            rules="required|valid_date|check_review_date:@reductionReviewDate"
                            v-slot="{ errors, classes }"
                          >
                            <cleave
                              v-model="reduction.reductionDate"
                              :options="formatOptions.date"
                              :raw="false"
                              name="date-of-reduction"
                              type="text"
                              class="form-control"
                              :class="classes"
                              placeholder="DD / MM / YYYY"
                            ></cleave>
                            <span class="error">{{ errors[0] }}</span>
                          </ValidationProvider>
                        </div>
                      </mdb-col>
                    </mdb-row>

                    <mdb-row v-if="validDate(reduction.reductionDate)">
                      <mdb-col
                        class="col-12 p-0 pr-5 pt-3 pb-3"
                        v-if="superScheme === Enum.superScheme.PSS"
                      >
                        <div class="form-group">
                          <mdb-tooltip
                            trigger="hover"
                            boundrySelector="#about-inset"
                            :options="{ placement: 'left' }"
                          >
                            <span slot="tip">
                              Select 'yes' if a partial invalidity pension has
                              been approved by CSC as a result of this salary
                              reduction
                            </span>
                            <span class="icon-info" slot="reference"></span>
                          </mdb-tooltip>

                          <label for="pip-payable">
                            Is a PIP payable as a result of this reduction?
                          </label>
                          <input type="hidden" id="pip-payable" />
                          <br />
                          <mdb-btn-group class="multi-select-group">
                            <mdb-btn
                              class="multi-select"
                              value="YES"
                              @click.native="
                                togglePipPayableBtn({ $event, index })
                              "
                              :class="[
                                { active: pipPayableToggle[index] == true }
                              ]"
                              >Yes</mdb-btn
                            >
                            <mdb-btn
                              class="multi-select"
                              value="NO"
                              @click.native="
                                togglePipPayableBtn({ $event, index })
                              "
                              :class="[
                                { active: pipPayableToggle[index] == false }
                              ]"
                              >No</mdb-btn
                            >
                          </mdb-btn-group>
                        </div>
                      </mdb-col>

                      <mdb-col
                        class="col-12 p-0 pr-5 pt-3 pb-3"
                        v-if="
                          (superScheme === Enum.superScheme.CSS ||
                            superScheme === Enum.superScheme.PSS) &&
                            dateToNum(reduction.reductionDate) < Enum.july2003
                        "
                      >
                        <div class="form-group">
                          <mdb-tooltip
                            trigger="hover"
                            boundrySelector="#about-inset"
                            :options="{ placement: 'left' }"
                          >
                            <span slot="tip">
                              Select 'yes' if the member passed a birthday
                              between the date of reduction and 01/07/2003.
                            </span>
                            <span class="icon-info" slot="reference"></span>
                          </mdb-tooltip>

                          <label for="sal-review-completed">
                            Was a salary review completed between the date of
                            reduction and 01/07/2003?
                          </label>
                          <input type="hidden" id="sal-review-completed" />
                          <br />
                          <mdb-btn-group class="multi-select-group">
                            <mdb-btn
                              class="multi-select"
                              value="YES"
                              @click.native="
                                toggleSalReviewCompletedBtn({ $event, index })
                              "
                              :class="[
                                {
                                  active:
                                    salReviewCompletedToggle[index] == true
                                }
                              ]"
                              >Yes</mdb-btn
                            >
                            <mdb-btn
                              class="multi-select"
                              value="NO"
                              @click.native="
                                toggleSalReviewCompletedBtn({ $event, index })
                              "
                              :class="[
                                {
                                  active:
                                    salReviewCompletedToggle[index] == false
                                }
                              ]"
                              >No</mdb-btn
                            >
                          </mdb-btn-group>
                        </div>
                      </mdb-col>

                      <mdb-col class="col-12 p-0 pr-5 pt-3 pb-3">
                        <div class="form-group">
                          <mdb-tooltip
                            trigger="hover"
                            boundrySelector="#about-inset"
                            :options="{ placement: 'left' }"
                          >
                            <span slot="tip">
                              Enter the base salary your employee was receiving
                              on the relevant date. Don't include any
                              allowances.
                            </span>
                            <span class="icon-info" slot="reference"></span>
                          </mdb-tooltip>

                          <label for="base-salary-prior">
                            <span v-if="D16(index) && D21(index)">
                              Base salary as at 30/06/2003
                            </span>
                            <span v-else>
                              Base salary prior to salary reduction
                            </span>
                          </label>
                          <ValidationProvider
                            rules="required"
                            v-slot="{ errors, classes }"
                          >
                            <div class="input-group">
                              <div class="input-group-prepend">
                                <span class="input-group-text" :class="classes">
                                  $
                                </span>
                              </div>
                              <cleave
                                v-model="reduction.baseSalaryPrior"
                                :options="formatOptions.salary"
                                name="base-salary-prior"
                                type="text"
                                class="form-control"
                                :class="classes"
                                placeholder="Amount"
                              ></cleave>
                            </div>
                            <span class="error">{{ errors[0] }}</span>
                          </ValidationProvider>
                        </div>
                      </mdb-col>

                      <mdb-col class="col-12 p-0 pr-5 pt-3 pb-3">
                        <div class="form-group">
                          <mdb-tooltip
                            trigger="hover"
                            boundrySelector="#about-inset"
                            :options="{ placement: 'left' }"
                          >
                            <span slot="tip">
                              Enter the total amount of higher duties allowance
                              (HDA) your employee was receiving on the relevant
                              date. You need to complete this section even if
                              the higher duties allowance (HDA) continued to be
                              paid after the salary reduction.
                            </span>
                            <span class="icon-info" slot="reference"></span>
                          </mdb-tooltip>

                          <label for="hda-salary-prior">
                            <span v-if="D16(index) && D21(index)">
                              HDA as at 30/06/2003
                            </span>
                            <span v-else>
                              HDA prior to salary reduction
                            </span>
                          </label>
                          <ValidationProvider
                            rules="required"
                            v-slot="{ errors, classes }"
                          >
                            <div class="input-group">
                              <div class="input-group-prepend">
                                <span class="input-group-text" :class="classes">
                                  $
                                </span>
                              </div>
                              <cleave
                                v-model="reduction.hdaPrior"
                                :options="formatOptions.salary"
                                name="hda-salary-prior"
                                type="text"
                                class="form-control"
                                :class="classes"
                                placeholder="Amount"
                              ></cleave>
                            </div>
                            <span class="error">{{ errors[0] }}</span>
                          </ValidationProvider>
                        </div>
                      </mdb-col>

                      <mdb-col class="col-12 p-0 pr-5 pt-3 pb-3">
                        <div class="form-group">
                          <mdb-tooltip
                            trigger="hover"
                            boundrySelector="#about-inset"
                            :options="{ placement: 'left' }"
                          >
                            <span slot="tip">
                              Enter the total amount of recognised allowances
                              that your employee was receiving on the relevant
                              date. You need to include all recognised
                              allowances that were being received - apart from
                              higher duties allowance (HDA) - even if they
                              continued to be paid after the salary reduction.
                            </span>
                            <span class="icon-info" slot="reference"></span>
                          </mdb-tooltip>

                          <label for="allowance-prior">
                            <span v-if="D16(index) && D21(index)">
                              Allowance as at 30/06/2003
                            </span>
                            <span v-else>
                              Allowance prior to salary reduction (ex HDA)
                            </span>
                          </label>
                          <ValidationProvider
                            rules="required"
                            v-slot="{ errors, classes }"
                          >
                            <div class="input-group">
                              <div class="input-group-prepend">
                                <span class="input-group-text" :class="classes">
                                  $
                                </span>
                              </div>
                              <cleave
                                v-model="reduction.allowancePrior"
                                :options="formatOptions.salary"
                                name="allowance-prior"
                                type="text"
                                class="form-control"
                                :class="classes"
                                placeholder="Amount"
                              ></cleave>
                            </div>
                            <span class="error">{{ errors[0] }}</span>
                          </ValidationProvider>
                        </div>
                      </mdb-col>
                    </mdb-row>
                  </mdb-container>
                </mdb-col>
              </mdb-row>
              <!-- REDUCTION LOOP -->
            </ValidationObserver>
          </mdb-container>
        </div>
      </mdb-col>

      <mdb-col
        class="d-none d-lg-flex flex-grow-3 flex-snap align-self-end text-lg-left mb-4 pt-5 pt-lg-0"
      ></mdb-col>
    </mdb-row>

    <mdb-row class="pb-4 d-flex">
      <mdb-col class="flex-grow-7 flex-snap text-left p-0 pl-sm-2 pl-md-4">
        <div class="details-inset">
          <mdb-container fluid>
            <mdb-row class="text-left dots-left">
              <mdb-col class="pl-5 pt-5">
                &nbsp;
                <a
                  @click="addReduction()"
                  class="rounded btn btn-outline-primary ripple-parent"
                >
                  <i class="fas icon-add"></i> Add another reduction
                </a>
              </mdb-col>
            </mdb-row>

            <mdb-row class="text-left dots-left">
              <mdb-col class="pl-5 pt-5 pb-4">
                &nbsp;
              </mdb-col>
            </mdb-row>

            <mdb-row class="text-left">
              <mdb-col class="col-12 col-md-5 pt-2 pb-2 pl-5 small-circle">
                <p>
                  <a
                    class="underln"
                    href="javascript:;"
                    @click="showResetFields = true"
                  >
                    Reset all reductions
                  </a>
                </p>
              </mdb-col>
            </mdb-row>
          </mdb-container>
        </div>
      </mdb-col>

      <mdb-col
        class="flex-grow-3 flex-snap pt-3 pb-3 pt-md-0 pb-md-0 align-self-end text-center text-lg-left csc-btns-btm"
      >
        <router-link
          to="/about"
          class="rounded btn btn-outline-primary ripple-parent"
        >
          Back
        </router-link>
        <mdb-btn class="rounded" color="primary" @click.native="validateInputs">
          Calculate
          <i class="fas icon-arrow"></i>
        </mdb-btn>
      </mdb-col>

      <mdb-modal
        :show="showResetFields"
        @close="showResetFields = false"
        centered
      >
        <mdb-modal-header>
          <mdb-modal-title>Reset All Reductions?</mdb-modal-title>
        </mdb-modal-header>
        <mdb-modal-body class="text-left">
          This action will remove all current reduction data.
        </mdb-modal-body>
        <mdb-modal-footer>
          <mdb-btn
            class="rounded"
            outline="primary"
            @click.native="showResetFields = false"
            >Cancel</mdb-btn
          >
          <mdb-btn
            class="rounded"
            color="primary"
            @click.native="resetReductions"
            >Reset</mdb-btn
          >
        </mdb-modal-footer>
      </mdb-modal>
    </mdb-row>

    <mdb-row class="no-gutters">
      <mdb-col>
        <Footer />
        <div id="feedback">
          <a
            href="https://feedback.csc.gov.au/cgi-bin/qwebcorporate.dll?idx=SQ6N45&type=AHC"
            target="_blank"
          >
            Feedback
          </a>
        </div>
      </mdb-col>
    </mdb-row>
  </mdb-container>
</template>

<style lang="scss">
@import "~@/scss/details.scss";
</style>

<script>
import {
  mdbContainer,
  mdbRow,
  mdbCol,
  mdbBtn,
  mdbBtnGroup,
  mdbTooltip,
  mdbModal,
  mdbModalHeader,
  mdbModalTitle,
  mdbModalBody,
  mdbModalFooter
} from "mdbvue";

import { mapGetters, mapState } from "vuex";
import { mapMultiRowFields } from "vuex-map-fields";
import Cleave from "vue-cleave-component";
import WizardStep from "@/components/WizardStep.vue";
import Footer from "@/components/Footer.vue";
import { scroller } from "vue-scrollto/src/scrollTo";
import {
  ValidationProvider,
  ValidationObserver,
  configure,
  extend
} from "vee-validate";
import { required } from "vee-validate/dist/rules";

configure({
  classes: {
    invalid: "is-invalid"
  }
});

extend("required", {
  ...required,
  message: "This field is required"
});

extend("valid_date", dateVal => {
  if (dateVal !== null && dateVal.length === 10) {
    let now = new Date();
    let maxNum = parseInt("" + (now.getFullYear() + 3) + "1231");
    let dateNum = parseInt(
      dateVal
        .split("/")
        .reverse()
        .join("")
    );
    if (dateNum >= 19000101 && dateNum <= maxNum) {
      return true;
    }
  }

  return "This date is invalid";
});

extend("check_review_date", {
  params: ["reviewDate"],
  validate(dateVal, { reviewDate }) {
    if (dateVal !== null && dateVal.length === 10) {
      let dateNum = parseInt(
        dateVal
          .split("/")
          .reverse()
          .join("")
      );
      let reviewNum = parseInt(
        reviewDate
          .split("/")
          .reverse()
          .join("")
      );
      if (dateNum > parseInt(reviewNum)) {
        return false;
      }
    }
    return true;
  },
  message: "Reduction date cannot be after the review date"
});

export default {
  name: "Details",
  components: {
    mdbContainer,
    mdbRow,
    mdbCol,
    mdbBtn,
    mdbBtnGroup,
    mdbTooltip,

    mdbModal,
    mdbModalHeader,
    mdbModalTitle,
    mdbModalBody,
    mdbModalFooter,

    Cleave,
    ValidationProvider,
    ValidationObserver,
    WizardStep,
    Footer
  },

  computed: {
    ...mapMultiRowFields(["reductionData"]),
    ...mapState(["reductionData", "reviewType", "superScheme"]),
    ...mapGetters([
      "employeeName",
      "memberNumber",
      "birthDate",
      "reviewSalary",
      "reviewDate",
      "reductionCount",
      "formatOptions",
      "Enum"
    ])
  },

  methods: {
    setButtonDefaults() {
      for (var index = 0; index < this.reductionCount; index++) {
        // PSS ONLY
        if (this.superScheme === this.Enum.superScheme.PSS) {
          if (
            this.reductionData[index].pipPayable === null ||
            this.reductionData[index].pipPayable.length < 1
          ) {
            this.togglePipPayable(this.Enum.btnVal.NO, index);
          } else {
            this.togglePipPayable(this.reductionData[index].pipPayable, index);
          }
        }
        // CSS OR PSS
        if (
          this.superScheme === this.Enum.superScheme.CSS ||
          this.superScheme === this.Enum.superScheme.PSS
        ) {
          if (
            this.reductionData[index].salReviewCompleted === null ||
            this.reductionData[index].salReviewCompleted.length < 1
          ) {
            this.toggleSalReviewCompleted(this.Enum.btnVal.NO, index);
          } else {
            this.toggleSalReviewCompleted(
              this.reductionData[index].salReviewCompleted,
              index
            );
          }
        }
      }
      window.triggerResize();
    },

    D16: function(index) {
      if (
        this.reductionData[index] === null ||
        this.reductionData[index].reductionDate === null
      ) {
        return false;
      } else {
        return (
          this.dateToNum(this.reductionData[index].reductionDate) <
          this.Enum.july2003
        );
      }
    },

    D18: function(index) {
      if (
        this.reductionData[index] === null ||
        this.reductionData[index].pipPayable === null
      ) {
        return false;
      } else {
        return (
          this.superScheme === this.Enum.superScheme.PSS &&
          this.reductionData[index].pipPayable === this.Enum.btnVal.YES
        );
      }
    },

    D21: function(index) {
      if (
        this.reductionData[index] === null ||
        this.reductionData[index].salReviewCompleted === null
      ) {
        return false;
      } else {
        return (
          (this.superScheme === this.Enum.superScheme.CSS ||
            this.superScheme === this.Enum.superScheme.PSS) &&
          this.reductionData[index].salReviewCompleted === this.Enum.btnVal.YES
        );
      }
    },

    validDate: dateVal => {
      if (dateVal !== null && dateVal.length === 10) {
        let now = new Date();
        let maxNum = parseInt("" + (now.getFullYear() + 3) + "1231");
        let dateNum = parseInt(
          dateVal
            .split("/")
            .reverse()
            .join("")
        );
        if (dateNum >= 19000101 && dateNum <= maxNum) {
          window.triggerResize();
          return true;
        }
      }
      return false;
    },

    togglePipPayable(vType, index) {
      this.$set(this.pipPayableToggle, index, vType === this.Enum.btnVal.YES);
      this.$store.commit("updatePipPayable", { index: index, value: vType });
      window.triggerResize();
    },

    togglePipPayableBtn(e) {
      this.togglePipPayable(e.$event.target.value, e.index);
    },

    toggleSalReviewCompleted(vType, index) {
      this.$set(
        this.salReviewCompletedToggle,
        index,
        vType === this.Enum.btnVal.YES
      );
      this.$store.commit("updateSalReviewCompleted", {
        index: index,
        value: vType
      });
      window.triggerResize();
    },

    toggleSalReviewCompletedBtn(e) {
      this.toggleSalReviewCompleted(e.$event.target.value, e.index);
    },

    properCase: value => {
      return value === null
        ? ""
        : value.toLowerCase().replace(/^(.)|\s(.)/g, function($u) {
            return $u.toUpperCase();
          });
    },

    lowerCase: value => {
      return value === null ? "" : value.toLowerCase();
    },

    getFirstName: value => {
      return value === null ? "" : value.split(" ")[0];
    },

    formatCurrency: (value, noCents = false) => {
      return value === null
        ? ""
        : noCents
        ? value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
        : parseFloat(value)
            .toFixed(2)
            .toString()
            .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },

    formatSuperScheme: value => {
      return value === null
        ? ""
        : value.length > 3
        ? value.substring(0, 3) + value.substring(3).toLowerCase()
        : value;
    },

    reductionNumber: function(index) {
      if (this.reductionCount < 2) {
        return "";
      } else {
        return index + 1;
      }
    },

    dateToNum: dateVal => {
      return dateVal === null
        ? ""
        : parseInt(
            dateVal
              .split("/")
              .reverse()
              .join("")
          );
    },

    addReduction: function() {
      this.$store.commit("addReduction");
      this.setButtonDefaults();
      //window.resizeIframe();
    },

    deleteReduction: function(index) {
      this.$store.commit("deleteReduction", index);
      window.resizeIframe();
    },

    sortReductions: function() {
      this.$store.commit("sortReductions");
    },

    validateInputs() {
      const scrollTo = scroller();
      this.errors = [];

      this.$refs.observer.validate().then(success => {
        if (!success) {
          scrollTo("#formFields");
          this.reSubmit = true;
          window.resizeIframe();
        } else {
          this.sortReductions();
          this.$router.push({ name: "Result" });
        }
      });
    },

    resetReductions() {
      const scrollTo = scroller();
      this.$store.commit("resetReductions");
      this.setButtonDefaults();
      this.$refs.observer.reset();
      this.showResetFields = false;
      scrollTo("#formFields");
      window.resizeIframe();
    }
  },

  mounted() {
    // Check we have all the required data populated, redirect if not
    if (
      this.$store.state.employeeName === null ||
      this.$store.state.employeeName.length < 1
    ) {
      this.$router.push({ name: "Home" });
    }
    this.setButtonDefaults();
    window.triggerResize();
  },

  data() {
    return {
      showResetFields: false,
      errors: [],
      pipPayableToggle: {},
      salReviewCompletedToggle: {}
    };
  }
};
</script>
